import { Component } from "@angular/core";
import {MatLegacyDialogRef as MatDialogRef} from "@angular/material/legacy-dialog";

@Component({
    selector: 'mydocma-mm-faults-sync-status-info-popup',
    templateUrl: './mm-faults-sync-status-info-popup.component.html',
    styleUrls: ['./mm-faults-sync-status-info-popup.component.scss'],
    providers: []
  })
  export class MmFaultsSyncStatusInfoPopupComponent {

    constructor(public dialogRef: MatDialogRef<MmFaultsSyncStatusInfoPopupComponent>) {}

    close() {
      this.dialogRef.close();
    }
}
